import React, { createContext, useState } from 'react';

import MeetSanctionConfigurationData from './MeetSanctionConfigurationData';

export const MeetSanctionConfigurationStateContext = createContext();

const MeetSanctionConfigurationContextProvider = ({ children }) => {
  const stateHook = useState(MeetSanctionConfigurationData.INITIAL_STATE);

  return (
    <MeetSanctionConfigurationStateContext.Provider value={stateHook}>
      {children}
    </MeetSanctionConfigurationStateContext.Provider>
  );
};

export default MeetSanctionConfigurationContextProvider;